// extracted by mini-css-extract-plugin
export var hideEditor = "_s7-2";
export var infoIcon = "_s7-3";
export var label = "_s7-1";
export var labelContainer = "_s7-0";
export var readonlyText = "_s7-4";